import React from 'react';
import AboutMe from './AboutMe/AboutMe';
import Portfolio from './Portfolio';
import Resume from './Resume/Resume';
import Blog from './Blog';
import Contact from './Contact';
class Content extends React.Component {

    render() {

        return (
            <div id="main" className="site-main">
                {/* Page changer wrapper */}
                <div className="pt-wrapper">
                    <div className="subpages">
                        <AboutMe description={this.props.aboutmeDescription} />
                        <Resume />
                        <Portfolio />
                        <Blog />
                        <Contact />
                    </div>
                </div>
                {/* /Page changer wrapper */}
            </div>
        )
    }
}

export default Content;